import $ from 'jquery';

function makeEmbedHtml(id) {
  return `
  <div class="yt-video-container">
    <div class="pad-16x9"></div>
    <iframe width="560" height="315" src="https://www.youtube.com/embed/${id}?enablejsapi=1" frameborder="0" allowfullscreen></iframe>
  </div>`;
}

function replaceElement(el) {
  const $el = $(el);
  const id = $el.attr('data-yt-video-id');
  $el.replaceWith(makeEmbedHtml(id));
}

function findAndReplace(selector = '.js-yt-video-placeholder') {
  $(selector).each((index, el) => {
    replaceElement(el);
  });
}

function pauseVideo(container) {
  const $iframe = $(container).find('iframe');
  if ($iframe.length) {
    try {
      const win = $iframe[0].contentWindow;
      win.postMessage('{"event": "command", "func": "pauseVideo"}', '*');
    } catch (e) {

    }
  }
}

export {
  makeEmbedHtml,
  replaceElement,
  findAndReplace,
  pauseVideo
}